// @flow
import api from 'common/services/api';
import PagedResults from 'statsradio/modules/pagination/domain/pagedResults';
import type { CustomerInvitation } from '../types/RadioCustomer';
import RadioCustomer from '../types/RadioCustomer';

class CustomersAPI {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async inviteCustomer(callSign: string, token: string, customer: CustomerInvitation): Promise<RadioCustomer> {
    const url = `/statsradio/radios/${callSign}/customers`;

    const toSend = { ...customer };
    const { data } = await api.post(url, toSend, { headers: this.buildHeaders(token) });

    return RadioCustomer.parse(data);
  }

  async fetchCustomersForStation(callSign: string, token: string): Promise<RadioCustomer[]> {
    const url = `/statsradio/radios/${callSign}/customers`;
    const { data } = await api.get(url, { limit: 999999, page: 1 }, { headers: this.buildHeaders(token) });

    return data.map(customer => RadioCustomer.parse(customer));
  }

  async fetchAllCustomers(token: string, page: number): Promise<PagedResults<RadioCustomer>> {
    const url = '/statsradio/radios/customers';
    const { data } = await api.get(url, { page: page, limit: 15 }, { headers: this.buildHeaders(token) });

    return PagedResults.parse(RadioCustomer.parse, data);
  }

  async deleteCustomer(callSign: string, token: string, customer: RadioCustomer): Promise<void> {
    const url = `/statsradio/radios/${callSign}/customers/${customer.reference}`;

    await api.del(url, { headers: this.buildHeaders(token) });
  }

  async editCustomer(callSign: string, token: string, customer: RadioCustomer): Promise<RadioCustomer[]> {
    const url = `/statsradio/radios/${callSign}/customers/${customer.getReference()}`;

    const { data } = await api.post(url, customer.toObject(), { headers: this.buildHeaders(token) });

    return data.map(radioCustomer => RadioCustomer.parse(radioCustomer));
  }
}


export default new CustomersAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/services/CustomersAPI.js